export default "assets/images/placement-check-85553446.svg";